module.exports = __webpack_public_path__ + "img/lu.0c2c3986.svg";